._item_1tqf4_1 {
  width: 304px;
  margin: 0 auto 10px; }

._itemName_1tqf4_5 {
  margin-bottom: 6px; }

._previewWrapper_1tqf4_8 {
  height: 168px;
  border-radius: 5px;
  background: #f1f8ff;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer; }

._previewWrapper_1tqf4_8:hover ._overlay_1tqf4_17, ._previewWrapper_1tqf4_8:active ._overlay_1tqf4_17, ._previewWrapper_1tqf4_8._active_1tqf4_17 ._overlay_1tqf4_17 {
  background: #7fccf7;
  visibility: visible;
  opacity: 0.07; }

._previewWrapper_1tqf4_8._landscape_1tqf4_22 {
  height: 114px; }

._preview_1tqf4_8 {
  position: relative;
  width: 100%;
  height: 100%; }

._preview_1tqf4_8 ._overlay_1tqf4_17 {
  position: relative;
  width: 100%;
  height: 100%;
  visibility: hidden;
  background: transparent; }

._preview_1tqf4_8 ._previewInner_1tqf4_37 {
  transform-origin: center;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%; }

._preview_1tqf4_8 ._snapshot_1tqf4_44 {
  pointer-events: none; }

._contextMenu_1tqf4_47 {
  display: none;
  position: absolute;
  top: 6px;
  right: 6px; }

._previewWrapper_1tqf4_8:hover ._contextMenu_1tqf4_47,
._previewWrapper_1tqf4_8._active_1tqf4_17 ._contextMenu_1tqf4_47 {
  display: block; }

._contextMenu_1tqf4_47 .context-menu-button {
  background: #fff; }

._contextMenuOptionsContainer_1tqf4_60 .context-menu-action svg path {
  fill: #2b5672 !important; }
